export default "__VITE_ASSET__ZBIztmmf__"